import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { Colors } from "constants/constants";
import { FC } from "react";

interface UtilizationVanTableYearProps {
  data: {
    number: string;
    total: number;
    type: number;
    months: {
      counter: number;
      month: number;
    }[];
  }[];
  date: string;
  station: string | undefined;
}

export const UtilizationVanTableYear: FC<UtilizationVanTableYearProps> = ({
  data,
  date,
  station,
}) => {
  return (
    <TableContainer style={{ maxHeight: "90vh", boxSizing: "border-box", padding: "0 10px" }}>
      <Table stickyHeader id="fleetPdf">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={8}>
              <Typography style={{ fontWeight: 600 }}>{station}</Typography>
            </TableCell>
            <TableCell align="right" colSpan={7}>
              <Typography style={{ fontWeight: 600 }}>Year {date}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography style={{ fontWeight: 600, textAlign: "center" }}>Type</Typography>
            </TableCell>
            <TableCell>
              <Typography style={{ fontWeight: 600, textAlign: "center" }}>Van</Typography>
            </TableCell>
            {data[0]?.months
              ? data[0]?.months.map((el) => (
                  <TableCell>
                    <Typography style={{ fontWeight: 600 }}>Month {el?.month}</Typography>
                  </TableCell>
                ))
              : []}
            <TableCell>
              <Typography style={{ fontWeight: 600 }}>Total</Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data
            ? data.map(
                (el) =>
                  el?.total > 0 && (
                    <TableRow
                      style={{
                        background: el?.total >= 240 ? Colors.PASTEL_RED : Colors.PASTEL_BLUE,
                      }}
                    >
                      <TableCell
                        style={{
                          background:
                            Number(el?.type) === 1
                              ? Colors.BLUE
                              : Number(el?.type) === 2
                                ? Colors.PASTEL_PINE_TREE
                                : Colors.PASTEL_YELLOW,
                        }}
                      >
                        <Typography style={{ textAlign: "center", color: "#fff" }}>
                          {Number(el?.type) === 1 ? "O" : Number(el?.type) === 2 ? "R" : "U"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography style={{ color: "#fff", textAlign: "center" }}>
                          {el?.number}
                        </Typography>
                      </TableCell>
                      {el?.months
                        ? el?.months.map((el) => (
                            <TableCell>
                              <Typography style={{ textAlign: "center", color: "#fff" }}>
                                {el?.counter}
                              </Typography>
                            </TableCell>
                          ))
                        : []}
                      <TableCell>
                        <Typography style={{ textAlign: "center", color: "#fff" }}>
                          {el?.total}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ),
              )
            : []}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
